import React, { useEffect, useState } from 'react';

import styles from './RelationshipCardAvgInbreeding.module.scss';
import { useTranslate } from 'react-polyglot';
import { useAuth } from '../../../../../../../Auth';
import { useAxios } from '../../../../../../../AxiosHandler';
import LineGraphCard from '../../../../Cards/LineGraphCard/LineGraphCard';

function RelationshipCardAvgInbreeding(props: RelationshipCardAvgInbreedingProps) {
    const t = useTranslate();
    const auth = useAuth();
    const axiosHandler = useAxios();
    const axios = axiosHandler.axios;

    const [data, setData] = useState<any>();
    
    function getData() {
        if (auth.selectedBreed == undefined) return;
        axios.single({
            method: 'get',
            url: "/api/statistics/relationship/breed/" + auth.selectedBreed + "/inbreeding",
            responseType: 'json',
            headers: { 'x-access-token': auth.user['token'], "selected-country": auth.selectedCountry || "all" }
        }).then((res) => {
            if (res.data?.length != 0) {
                setData({
                    labels: res.data.map((i: any) => i["YEAR"]),
                    datasets: [
                        {
                            label: t("statistics.areas.relationship.graphs.inbreeding.dataset_title"),
                            backgroundColor: "transparent",
                            pointBackgroundColor: "#68DB5A",
                            borderColor: "#68DB5A",
                            pointRadius: 2,
                            data: res.data.map((j: any) => j["AVERAGE_F"]),
                            tension: 0.5
                        }
                    ]
                });
            } else {
                setData(undefined);
            }
            props.onDataLoaded?.(res.data);
        }).catch((err) => {
            console.log(err);
        });
    }

    useEffect(() => {
        if (auth.selectedBreed != undefined) {
            getData();
        }
    }, [auth.selectedBreed, auth.selectedCountry]);

    return (
        <div className={styles.statisticshealth} style={{ display: data == undefined || data.length == 0 ? "none" : "block" }}>
            <LineGraphCard
                title={t("statistics.areas.relationship.graphs.inbreeding.title")}
                data={data}
                options={
                    {
                        scales: {
                            y: {
                                suggestedMin: 0,
                                suggestedMax: 30
                            }
                        }
                    }
                }
                description={t("statistics.areas.relationship.graphs.inbreeding.description")}
            ></LineGraphCard>
        </div>
    );
}

class RelationshipCardAvgInbreedingProps {
    onDataLoaded?: (data: any) => void;
}

export default RelationshipCardAvgInbreeding;